import { defineComponent, PropType } from "vue";

import { Station } from "~/api/models/station.model";
import widgetIndicator from "../widget-indicator/widget-indicator";

export default defineComponent({

    components: {
        widgetIndicator,
    },

    props: {
        station: { type: Object as PropType<Station>},
    },

    computed: {
        runtime(): number {
            
            const runtime: number | undefined = this.station?.latest_values?.run_time as number;

            if(runtime === undefined) {
                return 0;
            }
            
            return runtime;

        }
    }
});